module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/contentoffice/1.png?df1c39f18ea651f74a18ee5dc0ced547";